import { ApiError } from "../error-handler";
import { postHandler } from "../request-handler";

interface IEventRequestParams {
  date: string;
  email: string;
  event: string;
  notes: string;
  time: string;
}

/**
 * Call api to send email about new event request
 */
export async function sendEventRequest(
  params: IEventRequestParams,
): Promise<boolean> {
  const body = JSON.stringify(params);

  const response = await postHandler<boolean>("/event/request", body, false);

  if (response.error) {
    throw new ApiError(response.error);
  }

  return response.result;
}
